import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { PropType, ref } from 'vue';
import RenderFragment from './components/render-fragment.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    type: {
        type: String as PropType<'home'>,
        default: '',
    },
},
  setup(__props) {

const props = __props;



const pageData = ref<any>();

async function initPage() {
    if (props.type) {
        try {
            const res = await G_transmit('GetPageConfig', { queries: { type: props.type } });
            pageData.value = JSON.parse(res.data?.config ?? '{}');
        } catch (error) {
            console.error(error);
        }
    }
}

initPage();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value?.children, (item) => {
      return (_openBlock(), _createBlock(RenderFragment, {
        key: item.modelKey,
        template: item
      }, null, 8, ["template"]))
    }), 128))
  ]))
}
}

})